/**
 * Which single pane is visible at narrow widths.
 *
 * The desktop shell shows every pane at once and ignores this entirely — the `view-*` class on
 * `#app` only does anything inside the `max-width: 900px` media query. It lives here (rather than
 * in whichever component happens to set it) because two components change it — the bottom tab bar
 * and the nav rail — and they have to agree on which one is active.
 */

export type ViewId = 'view-explorer' | 'view-chat' | 'view-optimize' | 'view-account';

const VIEW_IDS: ViewId[] = ['view-explorer', 'view-chat', 'view-optimize', 'view-account'];
const NARROW_QUERY = '(max-width: 900px)';

const listeners = new Set<(view: ViewId) => void>();
let current: ViewId = 'view-chat';

export function getView(): ViewId {
  return current;
}

export function setView(view: ViewId): void {
  current = view;
  const app = document.getElementById('app');
  if (app) {
    for (const id of VIEW_IDS) app.classList.toggle(id, id === view);
  }
  for (const listener of listeners) listener(view);
}

export function onViewChange(listener: (view: ViewId) => void): void {
  listeners.add(listener);
}

/** True when the single-pane mobile layout is active. */
export function isNarrow(): boolean {
  return typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(NARROW_QUERY).matches : false;
}
